import { IMobileAccess, ITelevision } from "@nju/data-access-portal-product";

interface IGetTotalPriceProps {
  tvProducts: ITelevision | undefined;
  mobileAccessProducts: IMobileAccess | undefined;
}

export function getTotalPrice({
  mobileAccessProducts,
  tvProducts,
}: IGetTotalPriceProps) {
  const televisionPrice =
    tvProducts?.recurringPriceDiscount ?? (tvProducts?.recurringPrice || 0);

  const mobilePrice =
    mobileAccessProducts?.recurringPriceDiscount ??
    (mobileAccessProducts?.recurringPrice || 0);

  return mobilePrice + televisionPrice;
}
